import { createMonitoringLogger } from '@grafana/runtime';

export const sqlPluginLogger = createMonitoringLogger('features.plugins.sql');
